import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { getCarrierI18nKey } from '.';
import { useCheckoutState } from '../../../utils/checkoutState';
import { config, getAssetUrl } from '../../../utils/config';
import Price from '../../atoms/Price';
import './style.scss';

const ShippingOverview = () => {
  const { checkoutState } = useCheckoutState();
  const { formatMessage } = useIntl();

  const selectedDelivery = checkoutState.orderState.shipping?.selected?.[0];
  if (!selectedDelivery) {
    return <></>;
  }

  const overviewCarrierKey = getCarrierI18nKey(selectedDelivery.carrierGroupKey);
  const overviewShippingOptionKey = getCarrierI18nKey(selectedDelivery.shippingOptionKey);

  const shippingServiceCosts =
    config.basket.showNetPrices ? selectedDelivery?.serviceCosts?.withoutTax : selectedDelivery?.serviceCosts?.withTax;

  const overviewServiceCosts =
    shippingServiceCosts !== undefined ?
      shippingServiceCosts !== 0 ?
        <Price price={shippingServiceCosts} isLarge />
      : <FormattedMessage id="generic.free" />
    : null;

  const isShortDescriptionEnabled = config.shippingOptions.descriptions.short;
  const shortDescription = isShortDescriptionEnabled && (
    <>
      {formatMessage({
        id: `shipping.carrier.optionDescriptions.${overviewShippingOptionKey}.shortDescription`
      })}
      {selectedDelivery.deliveryDate && (
        <>
          {' - '}
          <FormattedDate value={new Date(selectedDelivery.deliveryDate)} month="long" day="numeric" />
        </>
      )}
    </>
  );

  return (
    <>
      <dd className="carrier-overview__carrier">
        <img src={getAssetUrl(`carriers/${overviewCarrierKey}.svg`)} alt="carrierKey" />
        <FormattedMessage id={`shipping.carrier.options.${overviewShippingOptionKey}`} />
      </dd>
      <dd className="carrier-overview__shipping-option">
        {overviewServiceCosts && <span>{overviewServiceCosts}</span>}
        {shortDescription && shortDescription}
      </dd>
    </>
  );
};

export default ShippingOverview;
